import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserNotificationSdk } from "../sdks/user-notification.sdk";

@Injectable({
	providedIn: 'root'
})
export class UserNotificationManager {
	public shouldNotify$: Observable<boolean>;
	private shouldNotifySource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private userNotificationSdk: UserNotificationSdk) {
		this.shouldNotify$ = this.shouldNotifySource.asObservable();
	}

	public refresh(): void {
		this.userNotificationSdk.get().subscribe(r => this.shouldNotifySource.next(r));
	}
}